import {createContext} from 'react';

const VideoPlayerStateContext = createContext({
  setVideoPlayerState: () => {},
  dockNode: null,
  playing: false,
  speed: 1
});

export default VideoPlayerStateContext;
